import React, { useEffect, useRef, useCallback } from 'react';
import { Link } from 'site-modules/shared/components/link/link';
import PropTypes from 'prop-types';
import { handleScrollIntoViewAndFocus } from 'client/site-modules/editorial/pages/top-rated/themes-2020/helper/scroll-into-view-and-focus';

export function CategoryLinks({ vehicleCardEntries }) {
  const parent = useRef();
  const handleClick = useCallback(e => {
    e.preventDefault();

    handleScrollIntoViewAndFocus(e.currentTarget.href, parent.current);
  });

  useEffect(() => {
    parent.current = window;
  }, []);

  return (
    <article className="container category-links d-flex justify-content-md-center px-0_75 px-md-0 my-2 py-md-2">
      {vehicleCardEntries.map(entry => {
        const href = `#${entry.metadata('anchorName').value()}`;

        return (
          <Link
            className="d-flex rounded-12 py-1 px-0_5 py-md-1_25 justify-content-center align-items-center flex-column"
            to={href}
            data-tracking-id="view_content"
            key={href}
            onClick={handleClick}
          >
            <div className="text-center">
              <p className="mb-0 text-blue-40 fw-bold">{entry.metadata('category-name').value()}</p>
              <p className="mb-0 text-cool-gray-10 size-14">
                {entry.child('vehicle-title').metadata('vehicle-title').value()}
              </p>
            </div>
          </Link>
        );
      })}
    </article>
  );
}

CategoryLinks.propTypes = {
  vehicleCardEntries: PropTypes.array.isRequired,
};
